import { legacy_connect, type Connect } from 'react-redux';

import type { IApplicationState } from '../../types/redux';

/**
 * В react-redux@9 `connect` deprecated (рекомендуют hooks).
 * `legacy_connect` — тот же API без warning.
 * DefaultState = IApplicationState вместо удалённого DefaultRootState.
 */
export const connect = legacy_connect as Connect<IApplicationState>;
